// @ts-nocheck
/**
 * Stub for `@workspace/object-storage-web`. Provides a useUpload hook;
 * uploads return a local object URL so previews work. Real upload TBD.
 */
export const useUpload = () => ({
  upload: async (file: File): Promise<{ url: string }> => ({ url: URL.createObjectURL(file) }),
  isUploading: false,
  progress: 0,
});
